<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="$modal.closeModal"
    >
      <header class="m-the-modal-header">
        <h5>ATENCIÓN</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section">
        <p>Los formatos de imagen permitidos son:</p>
        <ul class="a-list-clean display-flex-row-center flex-wrap margin-bottom-zero margin-top-xlarge">
          <li class="display-flex-row-center margin-bottom-medium margin-right-large">
            <i class="far fa-file-image font-size-large margin-right-xsmall text-color-content-image"></i>
            <span class="font-weight-bold">gif</span>
          </li>
          <li class="display-flex-row-center margin-bottom-medium margin-right-large">
            <i class="far fa-file-image font-size-large margin-right-xsmall text-color-content-image"></i>
            <span class="font-weight-bold">jpg</span>
          </li>
          <li class="display-flex-row-center margin-bottom-medium margin-right-large">
            <i class="far fa-file-image font-size-large margin-right-xsmall text-color-content-image"></i>
            <span class="font-weight-bold">jpeg</span>
          </li>
          <li class="display-flex-row-center margin-bottom-medium margin-right-large">
            <i class="far fa-file-image font-size-large margin-right-xsmall text-color-content-image"></i>
            <span class="font-weight-bold">png</span>
          </li>
        </ul>
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeContentEditorModalImageExtensionError',

  data () {
    return {
      buttonPrimary: {
        action: 'ENTENDIDO',
        class: 'a-button-assets-primary',
        sending: false,
        type: 'submit'
      }
    }
  }
}
</script>
